import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbstractService } from "../commons/abstract.service";
import { SearchParams } from "../commons/abstract.types";
import { ChatbotLogging, MostAcessedMenuData } from "../models/chatbot-logging.model";
@Injectable({ providedIn: 'root' })
export class ChatbotLoggingService extends AbstractService<ChatbotLogging> {

  constructor(private http: HttpClient) {
    super(http)
  }
  getURLBase(): string {
    return '/chatbot-logging';
  }

  preCreate(obj: ChatbotLogging): void {
    delete obj._id;
  }

  preUpdate(obj: ChatbotLogging): void { }

  getMostAccessedMenus(params?: Partial<SearchParams>): Observable<Array<MostAcessedMenuData>> {
    if (params && Object.keys(params).length > 0) {
      return super.getWithParams('/most-accessed', params);
    }
    return super.get('/most-accessed');
  }
}
